import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth-context";
import { LogOut } from "lucide-react";
import { toast } from "sonner";

export function SiteHeader() {
  const auth = useAuth();
  
  if (!auth) {
    return null;
  }
  
  const { member, logout } = auth;

  const handleLogout = () => {
    logout();
    toast.success("Logged out successfully");
  };

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">Venue Admin</h1>
        
        <div className="ml-auto flex items-center gap-4">
          {member && (
            <div className="flex items-center gap-2 text-sm">
              <span className="text-muted-foreground">{member.name}</span>
              <span className="text-xs text-muted-foreground">
                ({member.email_address})
              </span>
            </div>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="gap-2"
          >
            <LogOut className="h-4 w-4" />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
